module.exports = __webpack_public_path__ + "img/revenue-analyzer.f9e683f0.svg";